module.exports = __webpack_public_path__ + "static/media/graphicDesign.e42abb11.png";